import {contentManager} from '../../../api/contentManager';

import CertificateContentPage from '../../../api/certificatesContentPageEntity';
import { notifyBreadcrumChangeAction } from '../../../common/components/breadcrumb/actions/notifyBreadcrumChange';
import { actionTypes } from '../../../common/constants/actionTypes';

import { httpCallStartAction } from '../../../middlewares/http/actions';

export const fetchCertificateContentPageAction = () => (dispatch: any) => {
    dispatch(httpCallStartAction());

    contentManager.fetchCertificateContentPageAsync()
    .then((certificateItem) => {
      dispatch(fetchCertificateContentPageCompleted(certificateItem));
      dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_CERTIFICATES_PAGE, "Sertifikaatit"));
    });
};

const fetchCertificateContentPageCompleted = (certificatePage: CertificateContentPage) => ({
    meta: {
        httpEnd: true,
      },
    payload: certificatePage,
    type: actionTypes.FETCH_CERTIFICATES_ITEMS_COMPLETED
});


// WEBPACK FOOTER //
// ./src/components/certificatesPage/actions/fetchCertificateContentPage.ts